// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/image/laundry.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://use.typekit.net/ovt6ynt.css);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=EB+Garamond:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400;1,500;1,600;1,700;1,800&family=Oswald:wght@200;300;400;500;600;700&family=Roboto+Condensed:wght@300;400;700&family=Roboto:wght@100;300;400;500;700;900&family=Source+Sans+Pro:ital,wght@0,200;0,300;0,400;0,600;0,700;0,900;1,200;1,300;1,400;1,600;1,700;1,900&family=Spectral:wght@200;300;400;500;600;700;800&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-header {
  display: flex;
  width: 650px;
  height: 108.333px;
  justify-content: center;
  align-items: center;
  gap: 43px;
  flex-shrink: 0;
}

.header-h2 {
  font-family: "Ubuntu";
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 1px;
  color: #ccc;
}

@media (width < 1025px) {
  .header-h2 {
    font-size: 19px;
    font-weight: 700;
  }

  .page-header {
    width: 420px;
    height: 108.333px;
    gap: 43px;
  }
}

@media (width < 500px) {
  .header-h2 {
    font-size: 15px;
    font-weight: 700;
  }

  .page-header {
    width: 250px;
    height: 108.333px;
    gap: 23px;
  }
}

.mob-size {
  width: 30px;
  height: 30px;
  size: 20px;
}

.buttonLeft {
  display: flex;
  position: absolute;
  right: 11%;
  margin-top: 5px;
  padding: 0.5rem 1.2rem;
  box-shadow: 1px 1px 2px 1px rgba(0, 0, 0, 0.25);
  background: #1c1b1b;
  border: none;
  border-radius: 5px;
  color: #ccc;
}

.modal-stile-header-h2 {
  margin-bottom: 14%;
  color: #fffafa;
  padding: 0 20px 0 20px;
  text-align: center;
  font-family: Ubuntu;
  font-size: 21px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 1.1px;
}

.img-logo-laundry {
  margin: 37px 0% 30px 45%;

  width: 60px;
  height: 60px;
  padding: 28px;
  color: #ebce2c;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 100% 100%;
}

.modal-stile-section {
  display: flex;
  justify-content: center;
  width: 400px;
  text-align: start;
  flex-direction: column;
  background: #1d1c1c;
  box-shadow: 0px 8px 8px 2px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  margin: calc(0% + 7%) calc(5% - 15%) 0 calc(25% + 15%);
}

.modal-stile-label {
  font-size: 13px;
  font-family: Ubuntu;
  font-weight: 300;
  letter-spacing: 0.8px;
  color: #fff;
  margin-bottom: 4px;
  margin-left: 17%;
  text-align: start;
  display: flex;
  justify-content: flex-start;
  flex-flow: row nowrap;
}
.row-hover:hover {
  background-color: #3d3c3c;
}
.modal-stile-input {
  font-size: 14px;
  font-family: Ubuntu;
  letter-spacing: 0.7px;
  font-weight: 300;
  color: #ccc;
  flex-direction: column;
  background-color: #212121 !important;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25) inset;
  border-radius: 5px;

  margin: 0 60px 15px 60px;
  padding: 0.5rem 1rem;
}

/**/
.modal-stile-select {
  color: #fff;
  background: #001767;
  border-radius: 5px;
  border: none;
  margin: 0 67px 15px 67px;
  padding: 0.5rem 1.5rem;
  height: 1%;
  min-width: 50%;
}

.modal-stile-button {
  color: #fff;
  border-radius: 5px;
  outline: none;
  border: none;
  text-align: center;
  font-family: Ubuntu;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 0.7px;

  padding: 0.4rem 2.2rem;
}

.modal-stile-button:hover:not(:active) {
  box-shadow: 4px 4px 2px #0000008e;
  font-size: 15px;
}

.modal-stile-button:hover,
.modal-stile-button:not(:focus),
.modal-stile-button:not(:active) {
  outline: none;
  border: none;
}

.check-buttons {
  display: flex;
  justify-content: center;
  flex-wrap: nowrap;
  gap: 30px;
  margin-top: 10%;
  margin-bottom: 15%;
}

.confirmation-stile-header-h2 {
  margin-bottom: 8%;
  color: #fffafa;
  padding: 30px 30px 0 30px;
  text-align: center;
  font-family: Ubuntu;
  font-size: 22px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 1.1px;
}

.confirmation-stile-button {
  color: #fff;
  border-radius: 5px;
  outline: none;
  border: none;
  text-align: center;
  font-family: Ubuntu;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 0.7px;

  width: 35%;
  padding: 0.4rem 1.8rem;
}

.confirmation-stile-button:hover:not(:active) {
  box-shadow: 4px 4px 2px #0000008e;
  font-size: 15px;
}

.confirmation-stile-button:hover,
.confirmation-stile-button:not(:focus),
.confirmation-stile-button:not(:active) {
  outline: none;
  border: none;
}

.confirmation-check-buttons {
  display: flex;
  justify-content: center;
  flex-wrap: nowrap;
  gap: 30px;
  margin-top: 10%;
  margin-bottom: 20%;
}

.single-date-calendar {
  margin-left: 50px;
}

.filters-user {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 50px;
}

.filter-checkbox {
  margin-right: 1rem;
  display: flex;
  align-items: center;
  color: #fff;
}

.stile-select {
  color: #fff;
  background: #001767;
  border: none;
  margin-bottom: 1.8rem;
  border-radius: 5px;
  letter-spacing: 0.7px;
  padding: 0.5rem 1.7rem;

  width: 200px;
  padding: 8px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.filter-checkbox {
  display: block;
  margin-bottom: 8px;
}

.filter-checkbox input {
  margin-right: 8px;
}

.filter-checkbox {
  margin-bottom: 10px;
}

.stile-select {
  padding: 5px;
  margin-top: 10px;
}

.filter-stile-select {
  margin: 0;
  width: 250px;
  height: 35px;
  padding: 5px 0 8px;
  background: none;
  color: #fff;
  background: #001767;
  border-radius: 5px;
  border: none;
  margin-bottom: 20px;
  font-size: 14px;
  letter-spacing: 0.7px;
}

.filter-stile-select:focus,
.filter-stile-select:active,
.filter-stile-select:not(:focus) {
  outline: none;
  border: none;
}

.boxes {
  position: absolute;
  z-index: 1;
  width: 250px;
  padding: 0.8em 2em;
  color: #fff;
  background: #001767;
  border-radius: 0 0 5px 5px;
  margin-top: -23px;
  margin-bottom: 20px;
  letter-spacing: 0.7px;
}

@media (width < 500px) {
  .boxes {
    position: relative;
    z-index: 1;
  }

  .scerch-but {
    margin-bottom: 20px;
    margin-top: -40px;
  }
}

.scerch-but {
  display: flex;
}

input[type="checkbox"] {
  display: none;
}

input[type="checkbox"] + label {
  display: block;
  position: relative;
  padding-left: 35px;
  margin: 5px 0px;
  font: 13px/20px "Open Sans", Arial, sans-serif;
  color: #ddd;
  cursor: pointer;
}

input[type="checkbox"] + label:last-child {
  margin-bottom: 0.7em;
}

input[type="checkbox"] + label:before {
  content: "";
  display: block;
  width: 20px;
  height: 20px;
  border: 1.5px solid #fff;
  border-radius: 5px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0.6;
  transition: all 0.12s, border-color 0.08s;
}

input[type="checkbox"]:checked + label:before {
  width: 7px;
  top: -2px;
  left: 6px;
  border-radius: 0;
  opacity: 1;
  border-top-color: transparent;
  border-left-color: transparent;
  transform: rotate(45deg);
  z-index: 2;
}

input[type="checkbox"]:checked + label:after {
  content: "";
  display: block;
  width: 24px;
  height: 24px;
  border: 1.5px solid #fff;
  border-radius: 5px;
  position: absolute;
  background: #017ff7;
  left: -2px;
  top: -2px;
  box-sizing: border-box;
}

input[type="checkbox"] + label {
  color: #ddd;
}

input[type="checkbox"]:not(:checked) + label.inactive {
  color: #fff;
  opacity: 1;
}

.line-center {
  display: flex;
  flex-direction: row;
  align-self: baseline;
  align-items: center;
  justify-content: space-evenly;
  height: 100%;
  width: 100%;
  /* gap: -50px; */
  padding: 0 0vh 0 2vh;
}
.line-p {
  margin: 0;
  width: 32%;
  text-align: center;
  padding: 0.8vh 0vh;
}
.line-p-room {
  margin: 0;
  width: 50%;
  text-align: center;
  padding: 0vh 0vh;
}
.line-center-room {
  margin: 0;
  display: flex;
  flex-direction: row;
  align-self: center;
  align-items: center;
  justify-content:  center;
  height: 100%;
  width: 100%;
  padding: 0 0vh 0 0.0vh;
}
td {
  display: table-cell;
  vertical-align: inherit;
}
 `, "",{"version":3,"sources":["webpack://./src/pages/bots/laundry/laundry.css"],"names":[],"mappings":"AAGA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,SAAS;EACX;AACF;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,SAAS;EACX;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,sBAAsB;EACtB,+CAA+C;EAC/C,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;;EAExB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,cAAc;EACd,yDAAwD;EACxD,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,+CAA+C;EAC/C,mBAAmB;EACnB,sDAAsD;AACxD;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,oCAAoC;EACpC,qDAAqD;EACrD,kBAAkB;;EAElB,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA,GAAG;AACH;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,wBAAwB;EACxB,sBAAsB;EACtB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;;EAErB,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,eAAe;AACjB;;AAEA;;;EAGE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;;EAErB,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,eAAe;AACjB;;AAEA;;;EAGE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,eAAe;EACf,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;;EAEtB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,qBAAqB;AACvB;;AAEA;;;EAGE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE;IACE,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,8CAA8C;EAC9C,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,YAAY;EAEZ,yCAAyC;AAC3C;;AAEA;EACE,UAAU;EACV,SAAS;EACT,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,6BAA6B;EAC7B,8BAA8B;EAE9B,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,6BAA6B;EAC7B,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,YAAY;EACZ,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,uBAAuB;AACzB","sourcesContent":["@import url(\"https://use.typekit.net/ovt6ynt.css\");\n@import url(\"https://fonts.googleapis.com/css2?family=EB+Garamond:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400;1,500;1,600;1,700;1,800&family=Oswald:wght@200;300;400;500;600;700&family=Roboto+Condensed:wght@300;400;700&family=Roboto:wght@100;300;400;500;700;900&family=Source+Sans+Pro:ital,wght@0,200;0,300;0,400;0,600;0,700;0,900;1,200;1,300;1,400;1,600;1,700;1,900&family=Spectral:wght@200;300;400;500;600;700;800&display=swap\");\n\n.page-header {\n  display: flex;\n  width: 650px;\n  height: 108.333px;\n  justify-content: center;\n  align-items: center;\n  gap: 43px;\n  flex-shrink: 0;\n}\n\n.header-h2 {\n  font-family: \"Ubuntu\";\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  letter-spacing: 1px;\n  color: #ccc;\n}\n\n@media (width < 1025px) {\n  .header-h2 {\n    font-size: 19px;\n    font-weight: 700;\n  }\n\n  .page-header {\n    width: 420px;\n    height: 108.333px;\n    gap: 43px;\n  }\n}\n\n@media (width < 500px) {\n  .header-h2 {\n    font-size: 15px;\n    font-weight: 700;\n  }\n\n  .page-header {\n    width: 250px;\n    height: 108.333px;\n    gap: 23px;\n  }\n}\n\n.mob-size {\n  width: 30px;\n  height: 30px;\n  size: 20px;\n}\n\n.buttonLeft {\n  display: flex;\n  position: absolute;\n  right: 11%;\n  margin-top: 5px;\n  padding: 0.5rem 1.2rem;\n  box-shadow: 1px 1px 2px 1px rgba(0, 0, 0, 0.25);\n  background: #1c1b1b;\n  border: none;\n  border-radius: 5px;\n  color: #ccc;\n}\n\n.modal-stile-header-h2 {\n  margin-bottom: 14%;\n  color: #fffafa;\n  padding: 0 20px 0 20px;\n  text-align: center;\n  font-family: Ubuntu;\n  font-size: 21px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  letter-spacing: 1.1px;\n}\n\n.img-logo-laundry {\n  margin: 37px 0% 30px 45%;\n\n  width: 60px;\n  height: 60px;\n  padding: 28px;\n  color: #ebce2c;\n  background-image: url(../../../assets/image/laundry.png);\n  background-size: 100% 100%;\n}\n\n.modal-stile-section {\n  display: flex;\n  justify-content: center;\n  width: 400px;\n  text-align: start;\n  flex-direction: column;\n  background: #1d1c1c;\n  box-shadow: 0px 8px 8px 2px rgba(0, 0, 0, 0.25);\n  border-radius: 10px;\n  margin: calc(0% + 7%) calc(5% - 15%) 0 calc(25% + 15%);\n}\n\n.modal-stile-label {\n  font-size: 13px;\n  font-family: Ubuntu;\n  font-weight: 300;\n  letter-spacing: 0.8px;\n  color: #fff;\n  margin-bottom: 4px;\n  margin-left: 17%;\n  text-align: start;\n  display: flex;\n  justify-content: flex-start;\n  flex-flow: row nowrap;\n}\n.row-hover:hover {\n  background-color: #3d3c3c;\n}\n.modal-stile-input {\n  font-size: 14px;\n  font-family: Ubuntu;\n  letter-spacing: 0.7px;\n  font-weight: 300;\n  color: #ccc;\n  flex-direction: column;\n  background-color: #212121 !important;\n  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25) inset;\n  border-radius: 5px;\n\n  margin: 0 60px 15px 60px;\n  padding: 0.5rem 1rem;\n}\n\n/**/\n.modal-stile-select {\n  color: #fff;\n  background: #001767;\n  border-radius: 5px;\n  border: none;\n  margin: 0 67px 15px 67px;\n  padding: 0.5rem 1.5rem;\n  height: 1%;\n  min-width: 50%;\n}\n\n.modal-stile-button {\n  color: #fff;\n  border-radius: 5px;\n  outline: none;\n  border: none;\n  text-align: center;\n  font-family: Ubuntu;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  letter-spacing: 0.7px;\n\n  padding: 0.4rem 2.2rem;\n}\n\n.modal-stile-button:hover:not(:active) {\n  box-shadow: 4px 4px 2px #0000008e;\n  font-size: 15px;\n}\n\n.modal-stile-button:hover,\n.modal-stile-button:not(:focus),\n.modal-stile-button:not(:active) {\n  outline: none;\n  border: none;\n}\n\n.check-buttons {\n  display: flex;\n  justify-content: center;\n  flex-wrap: nowrap;\n  gap: 30px;\n  margin-top: 10%;\n  margin-bottom: 15%;\n}\n\n.confirmation-stile-header-h2 {\n  margin-bottom: 8%;\n  color: #fffafa;\n  padding: 30px 30px 0 30px;\n  text-align: center;\n  font-family: Ubuntu;\n  font-size: 22px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  letter-spacing: 1.1px;\n}\n\n.confirmation-stile-button {\n  color: #fff;\n  border-radius: 5px;\n  outline: none;\n  border: none;\n  text-align: center;\n  font-family: Ubuntu;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  letter-spacing: 0.7px;\n\n  width: 35%;\n  padding: 0.4rem 1.8rem;\n}\n\n.confirmation-stile-button:hover:not(:active) {\n  box-shadow: 4px 4px 2px #0000008e;\n  font-size: 15px;\n}\n\n.confirmation-stile-button:hover,\n.confirmation-stile-button:not(:focus),\n.confirmation-stile-button:not(:active) {\n  outline: none;\n  border: none;\n}\n\n.confirmation-check-buttons {\n  display: flex;\n  justify-content: center;\n  flex-wrap: nowrap;\n  gap: 30px;\n  margin-top: 10%;\n  margin-bottom: 20%;\n}\n\n.single-date-calendar {\n  margin-left: 50px;\n}\n\n.filters-user {\n  display: flex;\n  justify-content: flex-start;\n  flex-wrap: wrap;\n  gap: 50px;\n}\n\n.filter-checkbox {\n  margin-right: 1rem;\n  display: flex;\n  align-items: center;\n  color: #fff;\n}\n\n.stile-select {\n  color: #fff;\n  background: #001767;\n  border: none;\n  margin-bottom: 1.8rem;\n  border-radius: 5px;\n  letter-spacing: 0.7px;\n  padding: 0.5rem 1.7rem;\n\n  width: 200px;\n  padding: 8px;\n  font-size: 16px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.filter-checkbox {\n  display: block;\n  margin-bottom: 8px;\n}\n\n.filter-checkbox input {\n  margin-right: 8px;\n}\n\n.filter-checkbox {\n  margin-bottom: 10px;\n}\n\n.stile-select {\n  padding: 5px;\n  margin-top: 10px;\n}\n\n.filter-stile-select {\n  margin: 0;\n  width: 250px;\n  height: 35px;\n  padding: 5px 0 8px;\n  background: none;\n  color: #fff;\n  background: #001767;\n  border-radius: 5px;\n  border: none;\n  margin-bottom: 20px;\n  font-size: 14px;\n  letter-spacing: 0.7px;\n}\n\n.filter-stile-select:focus,\n.filter-stile-select:active,\n.filter-stile-select:not(:focus) {\n  outline: none;\n  border: none;\n}\n\n.boxes {\n  position: absolute;\n  z-index: 1;\n  width: 250px;\n  padding: 0.8em 2em;\n  color: #fff;\n  background: #001767;\n  border-radius: 0 0 5px 5px;\n  margin-top: -23px;\n  margin-bottom: 20px;\n  letter-spacing: 0.7px;\n}\n\n@media (width < 500px) {\n  .boxes {\n    position: relative;\n    z-index: 1;\n  }\n\n  .scerch-but {\n    margin-bottom: 20px;\n    margin-top: -40px;\n  }\n}\n\n.scerch-but {\n  display: flex;\n}\n\ninput[type=\"checkbox\"] {\n  display: none;\n}\n\ninput[type=\"checkbox\"] + label {\n  display: block;\n  position: relative;\n  padding-left: 35px;\n  margin: 5px 0px;\n  font: 13px/20px \"Open Sans\", Arial, sans-serif;\n  color: #ddd;\n  cursor: pointer;\n}\n\ninput[type=\"checkbox\"] + label:last-child {\n  margin-bottom: 0.7em;\n}\n\ninput[type=\"checkbox\"] + label:before {\n  content: \"\";\n  display: block;\n  width: 20px;\n  height: 20px;\n  border: 1.5px solid #fff;\n  border-radius: 5px;\n  position: absolute;\n  left: 0;\n  top: 0;\n  opacity: 0.6;\n  -webkit-transition: all 0.12s, border-color 0.08s;\n  transition: all 0.12s, border-color 0.08s;\n}\n\ninput[type=\"checkbox\"]:checked + label:before {\n  width: 7px;\n  top: -2px;\n  left: 6px;\n  border-radius: 0;\n  opacity: 1;\n  border-top-color: transparent;\n  border-left-color: transparent;\n  -webkit-transform: rotate(45deg);\n  transform: rotate(45deg);\n  z-index: 2;\n}\n\ninput[type=\"checkbox\"]:checked + label:after {\n  content: \"\";\n  display: block;\n  width: 24px;\n  height: 24px;\n  border: 1.5px solid #fff;\n  border-radius: 5px;\n  position: absolute;\n  background: #017ff7;\n  left: -2px;\n  top: -2px;\n  box-sizing: border-box;\n}\n\ninput[type=\"checkbox\"] + label {\n  color: #ddd;\n}\n\ninput[type=\"checkbox\"]:not(:checked) + label.inactive {\n  color: #fff;\n  opacity: 1;\n}\n\n.line-center {\n  display: flex;\n  flex-direction: row;\n  align-self: baseline;\n  align-items: center;\n  justify-content: space-evenly;\n  height: 100%;\n  width: 100%;\n  /* gap: -50px; */\n  padding: 0 0vh 0 2vh;\n}\n.line-p {\n  margin: 0;\n  width: 32%;\n  text-align: center;\n  padding: 0.8vh 0vh;\n}\n.line-p-room {\n  margin: 0;\n  width: 50%;\n  text-align: center;\n  padding: 0vh 0vh;\n}\n.line-center-room {\n  margin: 0;\n  display: flex;\n  flex-direction: row;\n  align-self: center;\n  align-items: center;\n  justify-content:  center;\n  height: 100%;\n  width: 100%;\n  padding: 0 0vh 0 0.0vh;\n}\ntd {\n  display: table-cell;\n  vertical-align: inherit;\n}\n "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
